const actions = {
  SET_STATE: 'filter/SET_STATE',
  APPLY: 'filter/APPLY',
  APPLY_AND_SEE_TRADES_LIST: 'filter/APPLY_AND_SEE_TRADES_LIST',
  RESET: 'filter/RESET',
}

export default actions
